import { render, staticRenderFns } from "./SellForm.vue?vue&type=template&id=230d437c&scoped=true"
import script from "./SellForm.vue?vue&type=script&lang=js"
export * from "./SellForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d437c",
  null
  
)

export default component.exports